import type { BackendApiErrorUnion } from '@vs-shop/engine/data/error/backendApi/_internal/createBackendApiError';
import { makeSearchModule } from '@vs-shop/engine/module/search/makeSearchModule';
import type { SearchSuggestAdapters } from '@vs-shop/engine/module/search/searchAdapters';
import { SuggestResult } from '../schema/openapi/backend';
import type { StripJsonLd } from '@vs-shop/schemas/transform/withoutJsonLd';

/**
 * Seam-C tenant bind (workspace#49 option C, layer 3).
 *
 * Instantiates the engine search module with rcprofi's `SuggestResult`
 * schema at module scope. Re-exports the record's members under their
 * pre-seam names so `search/getSearchSuggest.ts` callers repoint here with
 * an import-line-only change.
 */

const searchSuggestAdapters: SearchSuggestAdapters<StripJsonLd<SuggestResult>> = {
  counts: (suggest) => ({
    products: suggest.products.length,
    brands: suggest.brands.length,
    taxons: suggest.taxons.length,
    articles: suggest.articles.length,
  }),
};

const searchModule = makeSearchModule({
  suggestResult: SuggestResult,
  searchSuggestAdapters,
});

export const requestSearchSuggest = searchModule.requestSearchSuggest;
export const GetSearchSuggestError = searchModule.GetSearchSuggestError;
export type SearchGetSearchSuggestError = BackendApiErrorUnion<typeof GetSearchSuggestError>;
